import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';

function Message({ children, severity = 'error' }) {
  return (
    <Alert
      severity={severity}
      sx={{
        '.MuiAlert-root': {
          width: '80%',
          height: '50px',
        },
      }}
    >
      {children}
    </Alert>
  );
}

Message.propTypes = {
  children: PropTypes.node.isRequired,
  severity: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
};

export default Message;
